import React, { useState, useEffect } from 'react';

export default function LoadingAnimation() {
  const [docsCount, setDocsCount] = useState(0);
  const [sectionsCount, setSectionsCount] = useState(0);
  const [matchesCount, setMatchesCount] = useState(0);
  const [messageIndex, setMessageIndex] = useState(0);
  const [itemIndex, setItemIndex] = useState(0);

  const statusMessages = [
    "Analyzing sections...",
    "Fetching relevant paragraphs...",
    "Processing regulations...",
    "Searching for matches...",
    "Reviewing clauses...",
    "Examining provisions...",
    "Reconciling rules...",
    "Summarizing important provisions...",
  ];

  const scanningItems = [
    "SEC. 101 - General Provisions",
    "SEC. 132 - Front Setback Areas",
    "SEC. 155 - Parking Requirements",
    "SEC. 204 - Use Districts",
    "SEC. 303 - Conditional Uses",
    "Article 2 - Zoning Regulations",
    "Chapter 4 - Building Standards",
    "SEC. 142 - Screening Requirements",
    "SEC. 156 - Off-Street Parking",
    "SEC. 242 - Special Use Districts",
    "SEC. 250 Height And Bulk Districts Established",
    "SEC. 251 Height And Bulk Districts: Purposes",
    "SEC. 252 Classes Of Height And Bulk Districts",
    "SEC. 260 Height Limits: Measurement",
  ];

  useEffect(() => {
    const statsInterval = setInterval(() => {
      setDocsCount(prev => Math.min(prev + Math.floor(Math.random() * 50) + 20, 2847));
      setSectionsCount(prev => Math.min(prev + Math.floor(Math.random() * 100) + 50, 8932));
      setMatchesCount(prev => Math.min(prev + Math.floor(Math.random() * 3) + 1, 47));
    }, 200);

    const statusInterval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % statusMessages.length);
    }, 2000);

    const itemInterval = setInterval(() => {
      setItemIndex(prev => (prev + 1) % scanningItems.length);
    }, 1500);

    return () => {
      clearInterval(statsInterval);
      clearInterval(statusInterval);
      clearInterval(itemInterval);
    };
  }, []);

  return (
    <div className="loader-wrapper">
      <div className="loader-container">
        
        <div className="scanner-icon">
          <div className="document-stack">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="document"
                style={{
                  animationDelay: `${i * 0.3}s`,
                  zIndex: 3 - i,
                  opacity: 1 - i * 0.3
                }}
              />
            ))}
          </div>
          <div className="scan-line" />
        </div>

        <div className="fw-semibold fs-5">Scanning The Planning Code</div>
        
        <div className="status-text">
          {statusMessages[messageIndex]}
        </div>

        {/* <div className="stats-container">
          <div className="stat">
            <span className="stat-number">
              {docsCount.toLocaleString()}
            </span>
            <span className="stat-label">Documents</span>
          </div>
          <div className="stat">
            <span className="stat-number">
              {sectionsCount.toLocaleString()}
            </span>
            <span className="stat-label">Sections</span>
          </div>
          <div className="stat">
            <span className="stat-number">
              {matchesCount}
            </span>
            <span className="stat-label">Matches</span>
          </div>
        </div> */}

        <div className="progress-bar">
          <div className="progress-fill" />
        </div>

        <div className="scanning-items">
          Scanning: {scanningItems[itemIndex]}
        </div>

        <style>{`
          .loader-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          }

          .loader-container {
            text-align: center;
            padding: 40px;
            background: rgba(255, 255, 255, 0.95);
            border-radius: 20px;

            max-width: 500px;
            width: 100%;
          }

          .scanner-icon {
            width: 190px;
            height: 50px;
            margin: 0 auto 10px;
            position: relative;
          }

          .document-stack {
            width: 100%;
            height: 100%;
            position: relative;
          }

          .document {
            position: absolute;
            width: 30px;
            height: 40px;
            background: white;
            border: 2px solid #667eea;
            border-radius: 5px;
            left: 50%;
            transform: translateX(-50%);
            animation: scanDocument 2s ease-in-out infinite;
          }

          .scan-line {
            position: absolute;
            width: 100px;
            height: 3px;
            background: linear-gradient(90deg, transparent, #667eea, transparent);
            left: 50%;
            transform: translateX(-50%);
            animation: scan 2s linear infinite;
            box-shadow: 0 0 10px #667eea;
          }

          .title {
            color: #333;
            margin: 0 0 15px;
            font-size: 24px;
            font-weight: 600;
          }

          .status-text {
            color: #667eea;
            font-size: 16px;
            font-weight: 500;
            margin: 10px 0;
            min-height: 24px;
          }

          .stats-container {
            display: flex;
            justify-content: space-around;
            margin: 25px 0;
            padding: 20px;
            background: #f8f9ff;
            border-radius: 10px;
          }

          .stat {
            text-align: center;
          }

          .stat-number {
            font-size: 28px;
            font-weight: 700;
            color: #667eea;
            display: block;
            font-variant-numeric: tabular-nums;
          }

          .stat-label {
            font-size: 12px;
            color: #666;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-top: 5px;
            display: block;
          }

          .progress-bar {
            width: 100%;
            height: 8px;
            background: #e0e0e0;
            border-radius: 10px;
            overflow: hidden;
            margin-top: 20px;
          }

          .progress-fill {
            height: 100%;
            background: linear-gradient(90deg, #667eea, #764ba2);
            border-radius: 10px;
            animation: progress 60s ease-in-out;
          }

          .scanning-items {
            margin-top: 20px;
            font-size: 13px;
            color: #888;
            font-style: italic;
            min-height: 20px;
          }

          @keyframes scanDocument {
            0%, 100% {
              transform: translateX(-50%) translateY(0) scale(1);
            }
            50% {
              transform: translateX(-50%) translateY(-20px) scale(1.05);
            }
          }

          @keyframes scan {
            0% {
              top: 0;
              opacity: 0;
            }
            50% {
              opacity: 1;
            }
            100% {
              top: 100%;
              opacity: 0;
            }
          }

          @keyframes progress {
            0% {
              width: 0%;
            }
            50% {
              width: 70%;
            }
            100% {
              width: 100%;
            }
          }
        `}</style>
      </div>
    </div>
  );
}